import styled from 'styled-components'

export interface Props {
  disabled?: boolean
  $alternate?: boolean
  $clear?: boolean
}

const Button = styled.button<Props>`
  background-color: ${(p: Props) =>
    p.disabled
      ? '#f2f2f2'
      : p.$alternate
        ? 'transparent'
        : p.$clear
          ? 'transparent'
          : '#34bebd'};
  margin: 10px;
  padding: 20px 0;
  cursor: pointer;
  border-radius: 10px;
  border: ${(p: Props) => (p.$alternate ? '1px solid #082842' : '1px solid transparent')};
  border: ${(p: Props) => (p.$clear ? '1px solid transparent' : '')};
  width: 150px;
  height: 60px;
  letter-spacing: 0.23px;
  color: ${(p: Props) => (p.$alternate || p.disabled ? '#082842' : '#fff')};
  font:
    bold 15px Lato,
    sans-serif;
  outline: none;
`

export default Button
